import { useState, FormEvent } from 'react';
import { Product } from '../types';

interface EditProductModalProps {
  product: Product;
  onSubmit: (product: Product) => void;
  onCancel: () => void;
}

export function EditProductModal({ product, onSubmit, onCancel }: EditProductModalProps) {
  const [formData, setFormData] = useState({
    amazon_url: product.amazon_url,
    custom_name: product.custom_name,
    alert_threshold: product.alert_threshold.toString(),
  });
  const [error, setError] = useState('');

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    setError('');

    if (!formData.amazon_url || !formData.amazon_url.startsWith('http')) {
      setError('Veuillez entrer une URL Amazon valide');
      return;
    }

    if (!formData.custom_name.trim()) {
      setError('Veuillez entrer un nom pour le produit');
      return;
    }

    const threshold = parseFloat(formData.alert_threshold);
    if (isNaN(threshold) || threshold < 1 || threshold > 100) {
      setError('Le seuil doit être entre 1 et 100%');
      return;
    }

    onSubmit({
      ...product,
      amazon_url: formData.amazon_url.trim(),
      custom_name: formData.custom_name.trim(),
      alert_threshold: threshold,
    });
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      {error && (
        <div className="p-3 bg-red-900/30 border border-red-700 rounded-lg text-red-300 text-sm">
          {error}
        </div>
      )}

      <div>
        <label className="label">URL Amazon.fr</label>
        <input
          type="url"
          value={formData.amazon_url}
          onChange={(e) => setFormData({ ...formData, amazon_url: e.target.value })}
          className="input"
        />
      </div>

      <div>
        <label className="label">Nom personnalisé</label>
        <input
          type="text"
          value={formData.custom_name}
          onChange={(e) => setFormData({ ...formData, custom_name: e.target.value })}
          className="input"
        />
      </div>

      <div>
        <label className="label">Seuil d'alerte (%)</label>
        <input
          type="number"
          min="1"
          max="100"
          value={formData.alert_threshold}
          onChange={(e) => setFormData({ ...formData, alert_threshold: e.target.value })}
          className="input"
        />
      </div>

      <div className="flex justify-end gap-3 pt-4 border-t border-gray-700">
        <button type="button" onClick={onCancel} className="btn btn-secondary">Annuler</button>
        <button type="submit" className="btn btn-primary">💾 Sauvegarder</button>
      </div>
    </form>
  );
}